import { cva as t, ct as o, crv as e } from "@/styled-system/css";
const n = t({
  base: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "200ms ease background-color, box-shadow",
    boxShadow: {
      base: `inset 0 0 0 ${o("Button.borderWidths.default")} var(--shadow-color)`,
      _focusVisible: `inset 0 0 0 ${o("Button.borderWidths.default")} var(--shadow-color), {shadows.focus}`
    }
  },
  variants: {
    tone: {
      brand: {},
      neutral: {},
      critical: {}
    },
    emphasis: {
      filled: {},
      outlined: {}
    },
    disabled: {
      true: {},
      false: {
        cursor: "pointer"
      }
    },
    loading: {
      true: {},
      false: {}
    },
    ...e("fluid", {
      true: {
        width: "100%"
      },
      false: {
        width: "auto"
      }
    }),
    onImpact: {
      true: {},
      false: {}
    },
    size: {
      sm: {
        borderRadius: o("Button.radii.sm"),
        gap: o("Button.spacing.sm.gap.label-toIcon"),
        paddingBlock: o("Button.spacing.sm.padding.vert"),
        paddingInline: o("Button.spacing.sm.padding.horz")
      },
      md: {
        borderRadius: o("Button.radii.md"),
        gap: o("Button.spacing.md.gap.label-toIcon"),
        paddingBlock: o("Button.spacing.md.padding.vert"),
        paddingInline: o("Button.spacing.md.padding.horz")
      },
      lg: {
        borderRadius: o("Button.radii.lg"),
        gap: o("Button.spacing.lg.gap.label-toIcon"),
        paddingBlock: o("Button.spacing.lg.padding.vert"),
        paddingInline: o("Button.spacing.lg.padding.horz")
      }
    }
  },
  compoundVariants: [
    {
      loading: !1,
      disabled: !0,
      css: {
        opacity: "disabled"
      }
    },
    {
      size: ["sm"],
      css: {
        _after: {
          content: '""',
          position: "absolute",
          height: o("Button.sizes.sm.tapArea"),
          minWidth: o("Button.sizes.sm.tapArea"),
          width: "100%",
          left: "0",
          top: "50%",
          marginTop: `calc((${o("Button.sizes.sm.tapArea")} / 2) * -1)`
        }
      }
    },
    {
      emphasis: "filled",
      tone: "brand",
      css: {
        backgroundColor: {
          base: o("Button.colors.filled.brand.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.filled.brand.bg.hover"),
            _active: o("Button.colors.filled.brand.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.filled.brand.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.filled.brand.border.hover"),
            _active: o("Button.colors.filled.brand.border.pressed")
          }
        }
      }
    },
    {
      emphasis: "filled",
      tone: "critical",
      css: {
        backgroundColor: {
          base: o("Button.colors.filled.critical.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.filled.critical.bg.hover"),
            _active: o("Button.colors.filled.critical.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.filled.critical.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.filled.critical.border.hover"),
            _active: o("Button.colors.filled.critical.border.pressed")
          }
        }
      }
    },
    {
      emphasis: "outlined",
      tone: "brand",
      css: {
        backgroundColor: {
          base: o("Button.colors.outlined.brand.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.outlined.brand.bg.hover"),
            _active: o("Button.colors.outlined.brand.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.outlined.brand.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.outlined.brand.border.hover"),
            _active: o("Button.colors.outlined.brand.border.pressed")
          }
        }
      }
    },
    {
      emphasis: "outlined",
      tone: "neutral",
      css: {
        backgroundColor: {
          base: o("Button.colors.outlined.neutral.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.outlined.neutral.bg.hover"),
            _active: o("Button.colors.outlined.neutral.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.outlined.neutral.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.outlined.neutral.border.hover"),
            _active: o("Button.colors.outlined.neutral.border.pressed")
          }
        }
      }
    },
    {
      onImpact: !0,
      emphasis: "filled",
      tone: "brand",
      css: {
        backgroundColor: {
          base: o("Button.colors.onImpact.filled.brand.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.onImpact.filled.brand.bg.hover"),
            _active: o("Button.colors.onImpact.filled.brand.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.onImpact.filled.brand.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.onImpact.filled.brand.border.hover"),
            _active: o("Button.colors.onImpact.filled.brand.border.pressed")
          }
        }
      }
    },
    {
      onImpact: !0,
      emphasis: "outlined",
      tone: "neutral",
      css: {
        backgroundColor: {
          base: o("Button.colors.onImpact.outlined.neutral.bg.default"),
          _notDisabled: {
            _hover: o("Button.colors.onImpact.outlined.neutral.bg.hover"),
            _active: o("Button.colors.onImpact.outlined.neutral.bg.pressed")
          }
        },
        boxShadowColor: {
          base: o("Button.colors.onImpact.outlined.neutral.border.default"),
          _notDisabled: {
            _hover: o("Button.colors.onImpact.outlined.neutral.border.hover"),
            _active: o("Button.colors.onImpact.outlined.neutral.border.pressed")
          }
        }
      }
    }
  ]
});
export {
  n as buttonRecipe
};
//# sourceMappingURL=button-root.styles.js.map
